export default function sortByObligueDate(arr) {
  if (arr && arr.length > 0) {
    const sortedArr = arr.sort((a, b) => {
      const dateA = new Date(a.start.split('/').reverse().join('-'));
      const dateB = new Date(b.start.split('/').reverse().join('-'));
      return dateB - dateA; // Descending order
    });
    return sortedArr
  } else {
    return arr
  }
}
